import React, { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { format } from "date-fns";
import { ResponsiveLine } from "@nivo/line";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  AreaChart,
  Area,
  ResponsiveContainer,
} from "recharts";
import Dots from "../../../Loading/Dots";

import Typography from "../../../../components/Typography";

import * as APIDashboard from "../../../../services/nps/functions";

import { ReactComponent as EmptyState } from "../../../../build/images/emptystatemanagerhorizontal.svg";

import "./nps-date-five.css";
import Paperplane from "../../../Loading/Paperplane";

export default function NpsDateFive({ midias }) {
  const filtersDashboard = useSelector((state) => state.npsfilters);

  const [initialDate, setInitialDate] = useState(filtersDashboard.datestart);
  const [finalDate, setFinalDate] = useState(filtersDashboard.dateend);
  const [csatDay, setCsatDay] = useState([]);
  const [csatChannel, setCsatChannel] = useState([]);
  const [formats, setFormats] = useState({
    formatAxis: "%d/%m",
    formatTick: "every day",
    formatScale: "%Y-%m-%d",
    formatPrecision: "day",
  });
  const [dispareFilter, setDispareFilter] = useState(false);
  const [loading, setLoading] = useState(false);

  const data02 = [
    {
      data: [
        {
          x: "2018-01-01",
          y: 7,
        },
      ],
      id: "fake corp. A",
    },
  ];

  // const data = [
  //   {
  //     id: "webchat",
  //     color: "#455cc7",
  //     data: [
  //       { x: "Webchat", y: 49 },
  //       { x: "Voz", y: 100 },
  //       { x: "Whatsapp", y: 102 },
  //       // Adicione outros pontos de dados conforme necessário
  //     ],
  //   },
  //   {
  //     id: "voice",
  //     color: "#F2BD00",
  //     data: [
  //       { x: "Webchat", y: 200 },
  //       { x: "Voz", y: 110 },
  //       { x: "Whatsapp", y: 17 },
  //       // Adicione outros pontos de dados conforme necessário
  //     ],
  //   },
  //   {
  //     id: "whatsapp",
  //     color: "#008908",
  //     data: [
  //       { x: "Webchat", y: 180 },
  //       { x: "Voz", y: 80 },
  //       { x: "Whatsapp", y: 77 },
  //       // Adicione outros pontos de dados conforme necessário
  //     ],
  //   },
  // ];

  async function getCsatDay() {
    const response = await APIDashboard.getCsatDay(
      filtersDashboard.business.map((option) => option.id).join(),
      filtersDashboard.units.map((option) => option.id).join()
    );

    if (response && response.status === 200) {
      const data = response.data;

      if (data.length) {
        const graphicData = data.map((datum) => {
          return {
            name: `${format(
              new Date(datum.data.replaceAll("-", "/")),
              "dd/MM"
            )}`,
            resultado: Number(datum.resultado),
          };
          // return {
          //   x: `${datum.data}`,
          //   y: datum.resultado,
          // };
        });

        // graphicData.push({
        //   name: "10/01",
        //   resultado: 80,
        // });
        // graphicData.push({
        //   name: "12/01",
        //   resultado: 100,
        // });
        setCsatDay(graphicData);
        // setCsatDay([
        //   {
        //     data: graphicData,
        //     id: "Csat Day",
        //     color: "#455CC7",
        //   },
        // ]);
      } else {
        setCsatDay([]);
      }
    } else {
      console.log(
        "Falha, não foi possível carregar as informações!",
        "Verifique sua conexão e tente novamente mais tarde."
      );
      //   Toast(
      //     "Falha, não foi possível carregar as informações!",
      //     "Verifique sua conexão e tente novamente mais tarde",
      //     "error"
      //   );
    }
  }

  async function getCsatDayChannel() {
    const response = await APIDashboard.getCsatDayChannel(
      format(new Date(filtersDashboard.datestart), "yyyy-MM-dd"),
      format(new Date(filtersDashboard.dateend), "yyyy-MM-dd"),
      filtersDashboard.business.map((option) => option.id).join(),
      filtersDashboard.units.map((option) => option.id).join()
    );

    if (response && response.status === 200) {
      const data = response.data;
      const datasData = data.map((datum) => datum.data);
      const allData = datasData
        .filter((este, i) => {
          return datasData.indexOf(este) === i;
        })
        .sort();
      let dataFormated = [];
      const dataWhats = [];
      const dataWeb = [];
      const dataVoz = [];
      let stringDate = handleFormats();

      if (data.length) {
        allData.forEach((datum) => {
          const dateSearch = data.filter((datam) => datam.data === datum);
          let objData = {
            name: format(new Date(datum.replaceAll("-", "/")), stringDate),
          };

          dateSearch.forEach((datum) => {
            if (datum.idmidia === 1) {
              //VOZ
              objData.voz = Number(datum.resultado);
            } else if (datum.idmidia === 2 || datum.idmidia === 7) {
              //WEBCHAT
              objData.webchat = Number(datum.resultado);
            } else if (datum.idmidia === 3) {
              //EMAIL
              objData.email = Number(datum.resultado);
            } else if (datum.idmidia === 4) {
              //FACEBOOK
              objData.facebook = Number(datum.resultado);
            } else if (datum.idmidia === 5) {
              //WHATSAPP
              objData.whatsapp = Number(datum.resultado);
            } else if (datum.idmidia === 6) {
              //INSTAGRAM
              objData.instagram = Number(datum.resultado);
            } else if (datum.idmidia === 8) {
              //TELEGRAM
              objData.telegram = Number(datum.resultado);
            } else if (datum.idmidia === 9) {
              //TWITTER
              objData.twitter = Number(datum.resultado);
            } else if (datum.idmidia === 10) {
              //LINKEDIN
              objData.linkedin = Number(datum.resultado);
            } else if (datum.idmidia === 11) {
              //GBM
              objData.gbm = Number(datum.resultado);
            } else if (datum.idmidia === 12) {
              //SMS
              objData.sms = Number(datum.resultado);
            }
          });

          dataFormated.push(objData);
        });

        setCsatChannel(dataFormated);
      } else {
        setCsatChannel([]);
      }
    } else {
      console.log(
        "Falha, não foi possível carregar as informações!",
        "Verifique sua conexão e tente novamente mais tarde."
      );
      //   Toast(
      //     "Falha, não foi possível carregar as informações!",
      //     "Verifique sua conexão e tente novamente mais tarde",
      //     "error"
      //   );
    }
  }

  const CustomYAxisTick = ({ x, y, payload }) => {
    return (
      <g transform={`translate(${20},${y + 4})`}>
        <text
          x={0}
          y={0}
          textAnchor="start"
          fill="rgba(0, 0, 0, 0.38)"
          style={{ fontFamily: "Inter", fontSize: 12 }}
        >
          {payload.value}%
        </text>
      </g>
    );
  };

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="custom-tooltip">
          <p className="label">{payload[0].payload.name}</p>
          {payload.map((load) => {
            return (
              <Typography.H5 weight="400" color="gray-180">
                {load.name.substring(0, 1).toUpperCase() +
                  load.name.substring(1)}
                : {load.value}%
              </Typography.H5>
            );
          })}
          {/* <Typography.H5 weight="400" color="gray-180">
            Webchat: {payload[0].payload.webchat}%
          </Typography.H5>
          <Typography.H5 weight="400" color="gray-180">
            Voz: {payload[0].payload.voz}%
          </Typography.H5>
          <Typography.H5 weight="400" color="gray-180">
            Whatsapp: {payload[0].payload.whatsapp}%
          </Typography.H5> */}
        </div>
      );
    }

    return null;
  };

  const handleFormats = () => {
    const dateInit = new Date(filtersDashboard.datestart);
    const dateEnd = new Date(filtersDashboard.dateend);
    const timeDiff = Math.abs(dateEnd.getTime() - dateInit.getTime());
    const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
    if (dateInit.toDateString() === dateEnd.toDateString()) {
      return "HH:mm";
    } else if (diffDays > 0 && diffDays < 61) {
      return "dd/MM";
    } else if (diffDays >= 61) {
      return "MM/yyyy";
    }
  };

  const handleColors = (id) => {
    if (id === 1) {
      //VOZ
      return "#455CC7";
    } else if (id === 2 || id === 7) {
      //WEBCHAT
      return "#FF7661";
    } else if (id === 3) {
      //EMAIL
      return "#F2BD00";
    } else if (id === 4) {
      //FACEBOOK
      return "#5E35B1";
    } else if (id === 5) {
      //WHATSAPP
      return "#008908";
    } else if (id === 8) {
      //TELEGRAM
      return "#29A9EA";
    } else if (id === 11) {
      //GBM
      return "#C90000";
    } else if (id === 12) {
      //SMS
      return "#D81B60";
    } else {
      return "#455CC7";
    }
  };

  const getAllData = async () => {
    setLoading(true);
    await getCsatDay();
    // handleFormats();
    await getCsatDayChannel();
    setDispareFilter(true);
    setLoading(false);
  };

  useEffect(() => {
    // handleFormats();
    if (midias) {
      getAllData();
    }
  }, []);

  useEffect(() => {
    if (filtersDashboard.active && dispareFilter) {
      // handleFormats();
      getAllData();
    }
  }, [filtersDashboard]);

  // useEffect(() => {
  //   if (csatChannel.length) {
  //     handleFormats();
  //   }
  // }, [csatChannel]);

  return (
    <section className="nps-date-five">
      <div className="nps-date-five__csat-month">
        <header>
          <h5>CSAT deste mês</h5>
        </header>

        {loading ? (
          <Paperplane className="nps-date-five__dots-loading" />
        ) : (
          <div className="nps-date-five__csat-month__graphic">
            {csatDay.length ? (
              <ResponsiveContainer width="100%" height="100%">
                <AreaChart
                  data={csatDay}
                  margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
                >
                  <defs>
                    <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                      <stop
                        offset="0.39%"
                        stopColor="rgba(69, 92, 199, 0.83)"
                        stopOpacity={0.8}
                      />
                      <stop
                        offset="100%"
                        stopColor="rgba(255, 255, 255, 0.00)"
                        stopOpacity={0}
                      />
                    </linearGradient>
                  </defs>
                  <XAxis dataKey="name" />
                  <YAxis tick={<CustomYAxisTick />} />
                  <CartesianGrid stroke="#f5f5f5" />
                  <Tooltip />
                  <Area
                    type="linear"
                    dataKey="resultado"
                    stroke="#455CC7"
                    fillOpacity={1}
                    fill="url(#colorUv)"
                    dot={{
                      stroke: "#455CC7",
                      strokeWidth: 2,
                      r: 5,
                      color: "white",
                    }}
                  />
                </AreaChart>
              </ResponsiveContainer>
            ) : (
              <div className="card-table__area-empty">
                <EmptyState />
              </div>
            )}
          </div>
        )}
      </div>

      <div className="nps-date-five__csat-by-channel">
        <header>
          <h5>CSAT por canal</h5>

          <div className="nps-date-five__csat-by-channel__tag">
            {midias.map((midia) => {
              return (
                <span className="nps-date-five__csat-by-channel__tag__span">
                  <div
                    className={`by-channel-${midia.name.toLowerCase()}__color`}
                  />

                  <h6 className="by-channel-h5">{midia.name}</h6>
                </span>
              );
            })}
            {/* <span className="nps-date-five__csat-by-channel__tag__span">
              <div className="by-channel-webchat__color" />

              <h6 className="by-channel-h5">Webchat</h6>
            </span>
            <span className="nps-date-five__csat-by-channel__tag__span">
              <div className="by-channel-voice__color" />

              <h6 className="by-channel-h5">Voz</h6>
            </span>
            <span className="nps-date-five__csat-by-channel__tag__span">
              <div className="by-channel-whatsapp__color" />

              <h6 className="by-channel-h5">Whatsapp</h6>
            </span> */}
          </div>
        </header>

        {loading ? (
          <Paperplane className="nps-date-five__dots-loading" />
        ) : (
          <div className="nps-date-five__csat-by-channel__graphic">
            {csatChannel.length ? (
              <ResponsiveContainer width="100%" height="100%">
                <LineChart
                  data={csatChannel}
                  margin={{
                    top: 5,
                    right: 30,
                    bottom: 5,
                  }}
                >
                  <CartesianGrid stroke="#f5f5f5" />
                  <XAxis dataKey="name" />
                  <YAxis tick={<CustomYAxisTick />} />
                  <Tooltip content={<CustomTooltip />} />
                  {midias.map((midia) => {
                    return (
                      <Line
                        type="linear"
                        dataKey={midia.name.toLowerCase()}
                        stroke={handleColors(midia.id)}
                        dot={false}
                      />
                    );
                  })}
                  <Line
                    type="linear"
                    dataKey={"voz"}
                    stroke={handleColors(1)}
                    dot={false}
                  />
                </LineChart>
              </ResponsiveContainer>
            ) : (
              <div className="card-table__area-empty">
                <EmptyState />
              </div>
            )}
            {/* {csatChannel.length ? (
            <ResponsiveLine
              data={csatChannel}
              animate
              theme={{
                fontFamily: "Inter",
                fontSize: 12,
                textColor: "rgba(0, 0, 0, 0.38)",
              }}
              axisBottom={{
                format: formats.formatAxis,
                legendOffset: -12,
                tickValues: formats.formatTick,
              }}
              axisLeft={{
                legendOffset: 12,
                format: (v) => `${v}%`,
                tickValues: 11,
              }}
              curve="monotoneX"
              enablePointLabel
              margin={{
                bottom: 60,
                left: 60,
                right: 40,
                top: 20,
              }}
              colors={{
                datum: "color",
              }}
              enablePoints={false}
              pointSize={8}
              pointColor={{ theme: "background" }}
              pointBorderWidth={2}
              pointBorderColor="#455cc7"
              useMesh
              // xFormat="time:%Y-%m-%d"
              xScale={{
                format: formats.formatScale,
                precision: formats.formatPrecision,
                type: "time",
                useUTC: false,
              }}
              yScale={{
                type: "linear",
              }}
              tooltip={({ point }) => {
                return (
                  <div
                    style={{
                      background: "white",
                      padding: "9px 12px",
                      border: "1px solid #ccc",
                    }}
                  >
                    <div>
                      Data:{" "}
                      {filtersDashboard.datestart.toDateString() ===
                      filtersDashboard.dateend.toDateString()
                        ? format(new Date(point.data.x), "dd/MM/yyyy HH:mm")
                        : format(new Date(point.data.x), "dd/MM/yyyy")}
                    </div>
                    <div>Porcentagem: {point.data.y}</div>
                  </div>
                );
              }}
            />
          ) : (
            "RETORNO VAZIO"
          )} */}
          </div>
        )}
      </div>
    </section>
  );
}
